// Share the same imports between route rendering and intent-based preloading.
// Loading code never fetches account data or changes a room.
export const routeModules = {
  account: () => import("../components/AccountDashboard"),
  host: () => import("../components/HostHub"),
  trivia: () => import("../components/HostBuilder"),
  draw: () => import("../components/RandomDraw"),
  party: () => import("../components/PartyBuilder"),
  publicDraw: () => import("../components/PublicDraw"),
  room: () => import("../components/GameRoom"),
};

export function preloadRoute(path: string) {
  const load = path.startsWith("/room/") ? routeModules.room
    : path.startsWith("/draw/") ? routeModules.publicDraw
    : path.startsWith("/account") || path === "/login" ? routeModules.account
    : path.startsWith("/host/trivia") ? routeModules.trivia
    : path.startsWith("/host/random-draw") ? routeModules.draw
    : /^\/host\/(two-truths|odd-one-out|sketch-whisper|night-before-gfc|rba-vs-economy|spy)/.test(path) ? routeModules.party
    : path === "/host" ? routeModules.host : null;
  // Speculative failure is harmless: rendering retries the import normally.
  if (load) void load().catch(() => {});
}
